import React from "react";
import { ChevronDown, Star } from "lucide-react";
import { useGetInstructorWiseAllCourseFeedbackQuery } from "../../services/instructor/instructor";

const StudentsFeedback = () => {
  const {
    data: feedBacksResponse,
    error,
    isLoading,
    isError,
  } = useGetInstructorWiseAllCourseFeedbackQuery();

  const response = feedBacksResponse ?? error?.data;
  const feedbacks = (response?.data || []).filter((item) => item?._id);
  const emptyMessage =
    response?.message || "No feedback available for your courses yet.";
  const isEmptyResponse = response?.success === false;
  const hasLoadError = isError && !isEmptyResponse;

  const getHoursAgo = (date) => {
    const hours = Math.floor(
      (Date.now() - new Date(date).getTime()) / (1000 * 60 * 60),
    );

    if (hours < 1) return "Just now";
    if (hours === 1) return "1 hour ago";

    return `${hours} hours ago`;
  };

   if (isLoading) {
    return (
      <div className="bg-white border border-[#E5E7EB] p-5 rounded-lg">
        Loading feedbacks...
      </div>
    );
  }

  if (hasLoadError) {
    return (
      <div className="rounded-lg border border-[#E5E7EB] bg-white p-5">
        <p className="text-sm text-red-500">Failed to load feedbacks.</p>
      </div>
    );
  }
  return (
    <div className="w-full max-w-none border border-[#E5E7EB] bg-white px-4 pt-5 xl:max-w-[448px]">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h2 className="text-xl leading-8 tracking-[-1%] font-semibold text-[#1D2026]">
          Students Feedback
        </h2>
{/* 
        <div className="relative inline-flex items-center">
          <select
            className="appearance-none border border-[#E9EAF0] text-sm leading-6 rounded-full pl-3 pr-9 py-[3px] text-[#1D2026] bg-white outline-none cursor-pointer"
            defaultValue="Student"
          >
            <option value="Student">Student</option>
            <option value="Course">Course</option>
            <option value="All">All</option>
          </select>

          <ChevronDown
            size={18}
            className="absolute right-3 pointer-events-none text-[#1D2026]"
          />
        </div> */}
      </div>

      {/* Feedback List */}

      {feedbacks.length === 0 ? (
        <div className="mt-4 rounded-lg border border-dashed border-[#E5E7EB] bg-[#FAFAFA] px-4 py-8 text-center">
          <p className="text-sm leading-6 text-[#6E7485]">{emptyMessage}</p>
        </div>
      ) : (
        <div className=" space-y-4 mt-12 max-h-[700px] overflow-y-auto pr-2">
          {feedbacks.map((item) => (
            <div
              key={item._id}
              className={`pb-6  border-b border-[#089BC4]
            `}
            >
              {/* User */}
              <div className="flex items-start gap-4">
                <img
                  src={item?.user?.profilePicture.secureUrl}
                  alt={item.user.firstName}
                  className="w-10 h-10 rounded-full object-cover"
                />

                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="font-medium font-['Inter'] text-[#1D2026] text-sm tracking-[-1%]">
                      {item?.user?.firstName} {item?.user?.lastName}
                    </h3>

                    <span className="text-[#9CA3AF]">•</span>

                    <span className="text-[#6E7485] text-xs font-['Inter']">
                     {getHoursAgo(item.updatedAt)}
                    </span>
                  </div>

                  <div className="flex items-center gap-0.5 mt-2">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        size={16}
                        fill={i < item.rating ? "#06B6D4" : "#fff"}
                        className="text-[#06B6D4]"
                      />
                    ))}
                  </div>

                  {/* Feedback */}
                  <p className="text-[#4E5566] text-sm leading-[22px] tracking-[-1%] mt-3">
                    {item.feedbackText}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StudentsFeedback;
